import { combineReducers } from 'redux';

import dialogSendPayment from './dialogChangeEmail';

const reducer = combineReducers({
  [dialogSendPayment.name]: dialogSendPayment.reducer,
});

export default reducer;
